var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useDialogs } from '../hooks/use-dialogs';
import { ManageTout, ManageToutDefaultProps } from './manage-tout';
import { SliceEditDialog } from './slice-edit-dialog';
import { useManagement } from '../hooks/use-management';
import { sliceConnectedFieldsText } from '../utils/slice-connected-fields-text';
var cls = classNames('slice-manage-tout');
export var SliceManageConnectionsToutDefaultProps = __assign({}, ManageToutDefaultProps);
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
var DialogStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceManageConnectionsTout',
  Container: styled(ManageTout)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Dialog: styled(SliceEditDialog)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles)
};
export var SliceManageConnectionsTout = function (props) {
  var componentProps = useComponentProps(My.NAME, SliceManageConnectionsToutDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity;
  var dialogs = useDialogs();
  var isCurrentProfile = useManagement().isCurrentProfile;
  var emptyTout = entity.emptyTout,
    ownEmptyTout = entity.ownEmptyTout;
  var onEditClick = function () {
    dialogs.push(React.createElement(My.Dialog, {
      entity: entity
    }));
  };
  return React.createElement(My.Container, {
    onClick: onEditClick,
    content: isCurrentProfile ? ownEmptyTout || emptyTout : emptyTout,
    defaultText: "Click here to connect related ".concat(sliceConnectedFieldsText(entity)),
    className: cls.name(className)
  });
};
SliceManageConnectionsTout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;